import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import "../css/ReviewSlider.css";
import { useInterval } from "../hooks/useInterval";

const ReviewSlider = ({ data, autoplay }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [touched, setTouched] = useState(false);

  const handleSlideChange = (val) => {
    let tmp = activeSlide + val;
    if (tmp > data.length - 1) {
      tmp = 0;
    } else if (tmp < 0) {
      tmp = data.length - 1;
    }
    setActiveSlide(tmp);
  };

  useInterval(() => {
    if (!touched) handleSlideChange(1);
  }, autoplay);

  return (
    <div className="r2-slider" onClick={() => setTouched(true)}>
      <div className="r2-slides">
        {data.map((el, i) => {
          return <Slide key={uuid()} index={i} data={el} activeSlide={activeSlide} handleSlideChange={handleSlideChange} />;
        })}
      </div>
      <div className="r2-slider__nav">
        {data.map((el, i) => {
          return (
            <span
              key={uuid()}
              className={`r2-slider__navlink ${activeSlide === i ? "active" : null}`}
              onClick={() => {
                setTouched(true);
                setActiveSlide(i);
              }}
            ></span>
          );
        })}
      </div>
    </div>
  );
};

export default ReviewSlider;

const Slide = ({ data, index, activeSlide, handleSlideChange }) => {
  return (
    <div className={`r2-slide ${activeSlide === index ? "active" : null}`}>
      <div className="r2-slide-content">
        <h3>{data.attributes.title}</h3>
        <h4 className="reviewname">{data.attributes.name}</h4>
        <div className="textreview">{data.attributes.reviewText}</div>
      </div>
    </div>
  );
};
